const messages = {
  title: "Cenovnici i brošure PROIZVOD",
  title_media: "Cenovnici i brošure PROIZVOD",
  description:
    "Preuzmite ovde najnovije brošure i letke o našim Bridgestone i Firestone gumama za putnička vozila, SUV-ove i kombije.",
  short_description:
    "Ovde možete pronaći podatke za društvene mreže, Instore-TV i više.",
  mediaCategories: {
    products: "Proizvodi",
    brand_and_solutions: "Brend i rešenja",
    season_and_promotions: "Sezona i promocije",
    format: "Format",
    cars_and_vans: "Automobil, SUV, Kombi",
    truck_and_buses: "Teška vozila i autobusi",
    motorcycle: "Motocikl",
    agriculture: "Poljoprivreda",
    construction_machinery: "Građevinska mašinerija",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materijali",
    brochures: "Brošure proizvoda",
    price_list: "Cenovnici",
    materials: "Materijali",
    video_in_store: "Video sa titlovima",
    video_online: "Video bez titlova",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Društvene mreže",
    logos: "Logoi",
    summer: "Leto",
    winter: "Zima",
    all_season: "Sve sezone",
    promotions: "Promocije",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIJSKA BIBLIOTEKA",
    description:
      "Dobrodošli u medijsku sekciju posvećenu   \n" +
      "Bridgestone i Firestone proizvodima.  \n <br> <br>" +
      "Otkrićete vizuelne prikaze proizvoda,   \n" +
      "logoe, kao i širok izbor   \n" +
      "banera, videa i digitalnih materijala   \n" +
      "za korišćenje na vašoj web stranici ili na   \n" +
      "društvenim mrežama.  ",
    bDrive: {
      title: "Fotografije proizvoda",
      description:
        "Trenutne slike   \n" +
        "mogu se preuzeti   \n" +
        "sa našeg B-\n" +
        "DRIVE portala.  ",
    },
  },
  buttons: {
    media: "OTKRIJTE",
  },
  searchMedia: "Unesite ključnu reč",
  searchResults: "Rezultati pretrage",
};

export default {
  messages,
};
